import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AiAdminShellComponent } from './pages/ai-admin-shell/ai-admin-shell.component';
import { AiDashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { AiSettingsPageComponent } from './pages/settings-page/settings-page.component';

const routes: Routes = [
    {
        path: '',
        component: AiAdminShellComponent,
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: 'dashboard',
                component: AiDashboardPageComponent,
            },
            {
                path: 'settings',
                component: AiSettingsPageComponent,
            },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AiAdminRoutingModule {}
